var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "i8-loader",
        class: { "i8-page-loader": _vm.isPageLoader }
      },
      [
        _c("div", { staticClass: "i8-loader-spinner", class: _vm.sizeClass }, [
          _c(
            "svg",
            { staticClass: "circular", attrs: { viewBox: "25 25 50 50" } },
            [
              _c("circle", {
                staticClass: "path",
                attrs: {
                  cx: "50",
                  cy: "50",
                  r: "20",
                  fill: "none",
                  stroke: _vm.color,
                  "stroke-width": _vm.strokeWidth,
                  "stroke-linecap": _vm.strokeLinecap,
                  "stroke-miterlimit": "10"
                }
              })
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a3626b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a3626b0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./shared/components/Loader.vue
// module id = pyXa
// module chunks = 0 1